/**
 * Pezzi condivisi dalle due righe di coda in veste v4 (`QueueRow` a card e
 * `QueueTableRow` a colonne, T34). Ricevono il `QueueRowModel` gia calcolato:
 * nessuna logica nuova nel markup.
 */
import React from 'react';
import { FilePen } from 'lucide-react';
import { S3Avatar, S3Badge } from '../v3/primitives';
import { pendingDraftsLabel, type QueueRowModel } from '../v3/queueModel';

/**
 * Badge «N bozze» (Task 46): risposte in bozza in attesa di approvazione.
 * Condiviso dalle quattro righe di coda (v3/v4, card/tabella); 0 = niente.
 */
export const DraftsBadge: React.FC<{ count: number }> = ({ count }) =>
  count > 0 ? (
    <S3Badge tone="warn" small title="Risposte in bozza in attesa di approvazione del responsabile del canale">
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
        <FilePen size={10} aria-hidden="true" />
        {pendingDraftsLabel(count)}
      </span>
    </S3Badge>
  ) : null;

/** Avatar v4: sovrapposti, foto reale (CT-41) e anello sull'utente corrente (N14). */
export const V4Avatars: React.FC<{ row: QueueRowModel; size: number }> = ({ row, size }) => (
  <span className="s4-avs">
    {row.assigneeInitials.map((ini, i) => (
      <span
        key={row.assigneeKeys[i]}
        className={`s4-av${row.assigneeSelf[i] ? ' s4-av--self' : ''}`}
        data-self={row.assigneeSelf[i] ? 'true' : undefined}
      >
        <S3Avatar initials={ini} size={size} title={row.assigneeNames[i]} src={row.assigneePhotos[i]} />
      </span>
    ))}
    {row.extraAssignees > 0 && <span className="s3-meta s4-avs__more">+{row.extraAssignees}</span>}
  </span>
);

/**
 * Valutazione: in v4 mono «★ N» (L309) con nome accessibile «Valutazione N su
 * 5» (CT-40). Il testo per i lettori di schermo resta quello della v3.
 */
export const V4Rating: React.FC<{ stars: number }> = ({ stars }) => (
  <span className="s4-stars" title={`Valutazione ${stars}/5`} role="img" aria-label={`Valutazione ${stars} su 5`}>
    <span aria-hidden="true">★ {stars}</span>
    <span className="s3-sr">Valutazione {stars} su 5</span>
  </span>
);
